// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1L49y","errorLogs":"styles_errorLogs__1iEto"};